module.exports = __webpack_public_path__ + "static/media/DL.fe218d26.png";